import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '@/components/Layout';
import Sidebar from '@/components/Sidebar';
import {getWebsiteInfo, type WebsiteInfo} from '@/api/api';
import styles from '@/styles/Contact.module.css';
import moduleStyles from '@/styles/global.module.css';

export default function Contact() {
    const [websiteInfo, setWebsiteInfo] = useState<WebsiteInfo | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    // Define breadcrumbs for this page
    const breadcrumbs = [
        {title: '首页', link: '/'},
        {title: '联系我们', link: '/contact'}
    ];

    useEffect(() => {
        const fetchWebsiteInfo = async () => {
            try {
                const response = await getWebsiteInfo();
                if (response.data.code === 1) {
                    setWebsiteInfo(response.data.data);
                } else {
                    setError('获取网站信息失败');
                }
            } catch (err) {
                setError('获取网站信息时发生错误');
                console.error('Error fetching website info:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchWebsiteInfo();
    }, []);

    return (
        <Layout>
            <div className={moduleStyles.pageny}>
                <div className={moduleStyles.container}>
                    <div className={moduleStyles.lujing}>
                        您当前位置：
                        {breadcrumbs.map((item, index) => (
                            <React.Fragment key={index}>
                                <Link to={item.link}>{item.title}</Link>
                                {index < breadcrumbs.length - 1 ? ' >> ' : ''}
                            </React.Fragment>
                        ))}
                    </div>
                    <div className={moduleStyles.clearfix}></div>

                    <div className={moduleStyles.pageLeftRightContainer}>
                        <Sidebar mainCategory="联系我们"/>

                        <div className={moduleStyles.pageRight}>
                            <div className={styles.contactContainer}>
                                <div className={styles.contactTitle}>联系我们</div>

                                {loading ? (
                                    <div className={styles.contactContent}>加载中...</div>
                                ) : error ? (
                                    <div className={styles.contactContent}>Error: {error}</div>
                                ) : websiteInfo ? (
                                    <div className={styles.contactContent}>
                                        <div className={styles.contactInfo}>
                                            <p>微信：{websiteInfo.wvNumber?.replace('@', '')}</p>
                                            <p>地址：{websiteInfo.address?.replace('@', '')}</p>
                                        </div>
                                    </div>
                                ) : (
                                    <div className={styles.contactContent}>暂无联系信息</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={moduleStyles.clearfix}></div>
            </div>
        </Layout>
    );
}
